
import Vue from 'vue'
import Block from '@/components/Block.vue'
import EmailValidation from '@/service/EmailValidation'

export default Vue.extend({
  name: 'ParentConsentPopup',
  components: {
    Block,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    email: '',
    messageHasBeenSent: false,
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
  }),
  methods: {
    resendEmail: function () {
      this.$api
        .put('/users/parent', { parentEmail: this.email })
        .finally(() => (this.messageHasBeenSent = true))
    },
    closeClick: function () {
      this.email = ''
      ;(this.$refs.resendEmailForm as any).resetValidation()
      this.messageHasBeenSent = false
      this.$store.dispatch('parentConsentPopup/hidePopup')
    },
  },
})
